interface CalendarProps {
    className?: string;
}

export default function Calendar({ className = "" }: CalendarProps) {
    return (
        <svg 
            width="24" 
            height="24" 
            viewBox="0 0 48 48" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path 
                d="M43 33V19H5V41C5 42.1046 5.89543 43 7 43H24" 
                stroke="currentColor" 
                strokeWidth="4" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
            <path 
                d="M5 10C5 8.89543 5.89543 8 7 8H41C42.1046 8 43 8.89543 43 10V19H5V10Z" 
                stroke="currentColor" 
                strokeWidth="4" 
                strokeLinejoin="round"
            />
            <path 
                d="M16 5V13" 
                stroke="currentColor" 
                strokeWidth="4" 
                strokeLinecap="round"
            />
            <path 
                d="M32 5V13" 
                stroke="currentColor" 
                strokeWidth="4" 
                strokeLinecap="round"
            />
            <circle 
                cx="30" 
                cy="32" 
                r="7" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="4"
            />
            <path 
                d="M36 37L42 42" 
                stroke="currentColor" 
                strokeWidth="4" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
        </svg>
    );
} 